<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">

         <!-- Overview back link -->
      <div class="overview-link" @click="onClick('chessvis_landing_page',t('Welcome to Chessvis'),'landing')">
        <ion-icon :icon="chevronBackOutline" class="overview-link-icon" aria-hidden="true" />
        <span>{{ t("ChessVis Overview") }}</span>
      </div>

      <div class="tile-grid">

        <div class="tile tile-teal" @click="onClick('tactics_gym_menu',t('Tactics Gym'),'new_menu')">
          <ion-icon :icon="barbellOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">{{ t("Tactics Gym") }}</span>
          <span class="tile-sub">{{ t("Puzzles, Visualization, Blindfold") }}</span>
        </div>

        <div class="tile tile-purple" @click="onClick('studio_menu',t('Studio'),'new_menu')">
          <ion-icon :icon="libraryOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">{{ t("Studio") }}</span>
          <span class="tile-sub">{{ t("Openings & Repertoire") }}</span>
        </div>

        <div class="tile tile-coral" @click="onClick('stable_menu',t('The Stable'),'new_menu')">
          <ion-icon :icon="appsOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">{{ t("The Stable") }}</span>
          <span class="tile-sub">{{ t("Verbal Chess & AI") }}</span>
        </div>

        <div class="tile tile-gray" @click="onClick('account_menu',t('Account'),'new_menu')">
          <ion-icon :icon="personCircleOutline" class="tile-icon" aria-hidden="true" />
          <span class="tile-label">{{ t("Account") }}</span>
          <span class="tile-sub">{{ t("Settings & preferences") }}</span>
        </div>

      </div>
    </ion-content>

    <BottomNav @bottom-click="onClick"/>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage, IonHeader, IonToolbar, IonTitle,
  IonButtons, IonButton, IonContent, IonIcon,
} from '@ionic/vue'
import {
  barbellOutline, libraryOutline, sparklesOutline,
  personCircleOutline, chevronBackOutline, appsOutline
} from 'ionicons/icons'
import BottomNav from '@/components/BottomNav.vue'
import { useConnectionStore } from '@/stores/connectionStore';
import { t } from '@/composables/translateText.js'

const emit = defineEmits(['menu-item-click'])

function onClick(path:string,label:string,menu : string) {
  console.log("ON CLICK",path)
  const connectionStore = useConnectionStore()
  connectionStore.setMenuInUse(null)
  connectionStore.setMenuSectionInUse(null)
  connectionStore.setIsUsingNewMenus(true)
  emit("menu-item-click",path,label,menu)

}
</script>

<style scoped>

/* ── Overview link ── */
.overview-link {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 13px;
  background: #0f0f22;
  border-bottom: 0.5px solid #2a2a4a;
  cursor: pointer;
  font-size: 16px;
  color: #AFA9EC;
}
 
.overview-link-icon {
  font-size: 15px;
}

ion-toolbar {
  --background: #12122a;
  --color: #ffffff;
  --border-color: #2a2a4a;
}

ion-title {
  font-size: 17px;
  font-weight: 500;
}

ion-button {
  --color: #AFA9EC;
}

ion-content {
  --background: #1a1a2e;
  height: 100%;
}

/* Remove any fixed height on .tile-grid and use this instead */
.tile-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
  height: calc(100% - 16px); /* fills available content height */
  box-sizing: border-box;
}

.tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 18px;
  padding: 24px 16px 20px;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.tile:active {
  opacity: 1.0;
  transform: scale(0.97);
}

.tile-icon { font-size: 36px; }

.tile-label {
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  line-height: 1.3;
}

.tile-sub {
  font-size: 12px;
  text-align: center;
  line-height: 1.3;
  opacity: 1.0;
}

.tile-teal { background: #085041; }
.tile-teal .tile-icon,
.tile-teal .tile-label { color: #9FE1CB; }
.tile-teal .tile-sub   { color: #5DCAA5; }

.tile-purple { background: #3C3489; }
.tile-purple .tile-icon,
.tile-purple .tile-label { color: #CECBF6; }
.tile-purple .tile-sub   { color: #AFA9EC; }

.tile-coral { background: #712B13; }
.tile-coral .tile-icon,
.tile-coral .tile-label { color: #F5C4B3; }
.tile-coral .tile-sub   { color: #F0997B; }

.tile-gray { background: #2a2a3a; }
.tile-gray .tile-icon,
.tile-gray .tile-label { color: #D3D1C7; }
.tile-gray .tile-sub   { color: #888780; }
</style>
